<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-row>
      <b-col md="4">
         <div>
       <b-modal
       v-model="authentificationBasic"
      title="Connexion via formulaire"
      title-class="text-black h6"
      id="modal1"
      hide-footer
      centered
      size="md"
    >
    <b-row>
      <b-col>
        <p> Cette adresse mail a ete cree avec un mot de passe veuillez rensigner votre mot de passe</p>
      </b-col>
    </b-row>
       </b-modal>
    </div>
        <div class="login" v-if="!process">
          <b-row align-h="center">
             
             <b-button variant="outline" to="/">
               <img src="@/assets/images/1.png" width="100" class="text-center"/>
             </b-button>
          </b-row>
          <b-row class="p-1">
            <b-col>
              <h1 class="text-center">Se connecter</h1>
            </b-col>
          </b-row>
          <b-row class="px-5">
            <b-col>
              <b-form>
                <b-row>
                  <b-col>
                    <b-input-group class="form-group mb-0">
                      <b-input-group-prepend>
                        <b-button  variant="outline-primary"
                          ><b-icon icon="people"></b-icon
                        ></b-button>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        placeholder="Nom d'utilisateur ou Adresse mail ou Téléphone"
                        v-model="$v.user.identifier.$model"
                        required  :class="{'is-invalid' :$v.user.identifier.$error }"
                        :formatter="toLower"
                      ></b-form-input>
                         <b-form-invalid-feedback v-if="!$v.user.identifier.required">
                        Votre identifiant est requis
                    </b-form-invalid-feedback>
                    </b-input-group>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col>
                    <b-input-group class="form-group mb-0">
                      <b-input-group-prepend>
                        <b-button variant="outline-primary"
                          ><b-icon icon="key"></b-icon
                        ></b-button>
                      </b-input-group-prepend>
                      <b-form-input
                        :type="passwordFieldType"
                        placeholder="Mot de passe"
                        v-model="$v.user.password.$model"
                        required
                        :class="{'is-invalid' :$v.user.password.$error }"
                      ></b-form-input>
                      <b-input-group-append is-text class="cursor">
                     <b-icon :icon="passwordToggleIcon" @click="showPassword" />
                      </b-input-group-append>
                         <b-form-invalid-feedback v-if="!$v.user.password.required">
                        Votre mot de passe est requis
                    </b-form-invalid-feedback>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                      <div class="float-right pt-1 pb-1">
                  <router-link tag="a" to="/forgot-password"
                    ><span class="text-primary"
                      >Mot de passe oublié ?</span
                    ></router-link
                  >
                </div>
                  </b-col>
                 
                </b-row>
               
                <b-row >
               
                  <b-col>
                    <b-button block variant="outline-primary" @click="login">Se connecter</b-button>
                  </b-col>
               
                </b-row>
                <br>
                <b-row> 
                  <div class="align-items-center mt-2">
                      <b-card-text class="text-primary">
                  <router-link tag="a" to="/register"
                    ><span class="text-secondary"
                      >Pas encore inscrit ? <strong>S'inscrire</strong></span
                    ></router-link
                  >
                        </b-card-text>
               
                    </div>
                  <b-col class="text-secondary">
                  </b-col>
                 
                </b-row>
              </b-form>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col> <vs-divider /></b-col>
            <b-col cols="1"> <p>Ou</p></b-col>
            <b-col> <vs-divider /></b-col>
          </b-row>
          <b-row class="social-icon text-center">
           
            <b-col align-self="center" sm="4" offset-lg="2">
              <b-button-group class="google-button" @click="signInWithGoogle">
                <span class="google-button__icon">
                  <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z"
                      id="Shape"
                      fill="#EA4335"
                    />
                    <path
                      d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z"
                      id="Shape"
                      fill="#FBBC05"
                    />
                    <path
                      d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z"
                      id="Shape"
                      fill="#4285F4"
                    />
                    <path
                      d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z"
                      fill="#34A853"
                    />
                  </svg>
                </span>
                <span class="google-button__text"
                  >Se connecter avec Google</span
                >
              </b-button-group>
            </b-col>
          
            
          </b-row>
          <b-row class="social-icon text-center">
              <b-col align-self="center" sm="4" offset-lg="2">
              <b-button-group class="google-button">
                <span class="google-button__icon">
                  <svg
                    viewBox="0 0 256 315"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M213.803394,167.030943 C214.2452,214.609646 255.542482,230.442639 256,230.644727 C255.650812,231.761357 249.401383,253.208293 234.24263,275.361446 C221.138555,294.513969 207.538253,313.596333 186.113759,313.991545 C165.062051,314.379442 158.292752,301.507828 134.22469,301.507828 C110.163898,301.507828 102.642899,313.596301 82.7151126,314.379442 C62.0350407,315.16201 46.2873831,293.668525 33.0744079,274.586162 C6.07529317,235.552544 -14.5576169,164.286328 13.147166,116.18047 C26.9103111,92.2909053 51.5060917,77.1630356 78.2026125,76.7751096 C98.5099145,76.3877456 117.677594,90.4371851 130.091705,90.4371851 C142.497945,90.4371851 165.790755,73.5415029 190.277627,76.0228474 C200.528668,76.4495055 229.303509,80.1636878 247.780625,107.209389 C246.291825,108.132333 213.44635,127.253405 213.803394,167.030988 M174.239142,50.1987033 C185.218331,36.9088319 192.607958,18.4081019 190.591988,0 C174.766312,0.636050225 155.629514,10.5457909 144.278109,23.8283506 C134.10507,35.5906758 125.195775,54.4170275 127.599657,72.4607932 C145.239231,73.8255433 163.259413,63.4970262 174.239142,50.1987249"
                        fill="#000000"
                      ></path>
                    </g>
                  </svg>
                </span>
                <span class="google-button__text">Se connecter avec Apple</span>
              </b-button-group>
            </b-col>

          </b-row>
        </div>
      <div v-else  class="
          h-100
          mx-auto
        
          .d-none .d-lg-block .d-xl-none .d-xl-block
          d-flex
          align-items-center
          justify-content-center
        "
      >
            <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      </b-col>
      <b-col
        class="
          section-Image
          h-100
          mx-auto
           d-lg-flex
           d-sm-inline-flex 
           d-none
          align-items-center
          justify-content-center
        "
      >
        <h1 class="align-middle h-100 text-white p-2 text-center">
          Vivez de belle experience avec les logements disponibles.
        </h1>
      </b-col>
    </b-row>
   
  </div>
</template>


<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import {baseURL} from '@/helpers/axios'
const {
  required
 
} = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      user:{
        identifier:null,
        password:null
      },
      authentificationBasic:false,
      show:false
    }
  },
  validations:{
    user:{
      identifier:{
        required
      },
      password:{
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      process:'loginProcess',
      success:'loginSuccess',
      error:'loginError'
    }),
    passwordFieldType () {
      if (this.show) return 'text'
      return 'password'
    },
    passwordToggleIcon () {
      return this.show ? 'eye' : 'eye-slash'
    }
  },
  watch:{
    $route: {
      immediate: true,
      handler () {
        if (this.$route.query.authBasic) {
          this.authentificationBasic = true
          this.user.identifier = this.$route.query.username
          this.$v.user.password.$error = true
        }
        if (this.$route.query.$2a$12$Zoy74IVMJqFRZSJBGV2NMu834ViSyRJ9itlUa9BgbOncKFBQ3cu) {
          this.loginWithGoogle({
            access_token :this.$route.query.$2a$12$Zoy74IVMJqFRZSJBGV2NMu834ViSyRJ9itlUa9BgbOncKFBQ3cu.toString()}
          )
        }
       
      }
    },
    success (val) {
      if (val) {
        this.$vs.notify({
          title: 'Connexion Reussie',
          text: val,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position:'top-right'
          
        })
        if (this.$route.query.redirect) {
          const path = this.$route.query.redirect
          this.$router.push(path)
        } else {
          this.$router.push('/')
        }
      }
    },
    error (val) {
      if (val) {
        if (val.data.statusCode === 401) {
          this.$vs.notify({
            title: 'Connexion echoué',
            text: 'Identifiants incorrects',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position:'top-right'
          })
        }
       
      }
    }
  },

  methods: {
    ...mapActions(['loginUser', 'loginWithGoogle']),
    toLower (value) {
      return value.toLowerCase()
    },
    showPassword () {
      this.show = !this.show
    },
    login () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loginUser({
          userIdentifier: this.user.identifier,
          password: this.user.password


        })
      }
    },
    signInWithGoogle () {
      window.location.href = `${baseURL}/oauth/google`
      return true
    }
  }
}
</script>

<style lang="scss">

.section-Image {
  background-color: wheat;
  background-image: url(../../assets/images/balon.jpg);
  min-height: 100vh;
  background-size: cover;
}
.login {
  @media (min-width: 1200px) {
    padding: 150px 20px 0px 20px;
  }
}

.google-button {
  height: 40px;
  border-width: 0;
  background: white;
  color: #737373;
  border-radius: 5px;
  white-space: nowrap;
  box-shadow: 1px 1px 0px 1px rgba(0, 0, 0, 0.05);
  transition-property: background-color, box-shadow;
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
  padding: 0;
  margin: 10px;
  width: 275px;
}
.google-button:hover {
  background: #ecebf0;
  box-shadow: 1px 4px 5px 1px;
  cursor: pointer;
}

.google-button__icon {
  display: inline-block;
  vertical-align: middle;
  margin: 8px 0 8px 8px;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
}

.google-button__text {
  display: inline-block;
  vertical-align: middle;
  padding: 10px 24px;
  font-weight: bold;
  color: black;
}
button ~ button {
  margin-left: 20px;
}
input :active {
  border-color: yellow;
}
</style>
